module.exports = __webpack_public_path__ + "img/cpu.8952c4d9.svg";